module.exports = __webpack_public_path__ + "static/media/3.2a2d62ac.svg";